import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePrimaryCategories } from '../../hooks/usePrimaryCategories';
import styles from './PrimaryCategories.module.css';

const PrimaryCategories = ({
    size = "Desktop 1440",
    selectedCategory = "Discover",
    onCategoryClick
}) => {
    const navigate = useNavigate();
    const { categories, imageLinks, getImageIdByLength, error } = usePrimaryCategories();

    // Error silencioso - los íconos no son críticos
    if (error) {
        console.error('Error loading category assets:', error);
    }

    const getHorizontalWidth = useCallback(() => {
        switch (size) {
            case "Desktop 1440":
                return 1210;
            case "Desktop 1200":
                return 1057;
            case "Tablet":
                return 600;
            case "Phone":
                return 362.4;
            default:
                return 1210;
        }
    }, [size]);

    const renderCategoryImage = useCallback((categoryName) => {
        const totalLength = categoryName.length;
        const imageId = getImageIdByLength(totalLength);
        const imageLink = imageLinks[imageId];
        
        if (!imageLink) return null;

        return (
            <div className={styles.imageContainer}>
                <img
                    src={imageLink}
                    alt={`icon for ${categoryName}`}
                    className={styles.image}
                />
            </div>
        );
    }, [imageLinks, getImageIdByLength]);

    const handleCategoryClick = useCallback((categoryName) => {
        // Check if we're in a test page
        const isTestPage = window.location.pathname.startsWith('/test');
        if (isTestPage) {
            if (onCategoryClick) {
                onCategoryClick(categoryName);
            }
            return;
        }

        // Find the corresponding path for the category
        const category = categories.find(cat => cat.name === categoryName);
        if (category) {
            navigate(`/${category.path}/all`);
        }

        if (onCategoryClick) {
            onCategoryClick(categoryName);
        }
    }, [onCategoryClick, navigate, categories]);

    return (
        <div 
            className={styles.container}
            style={{ width: getHorizontalWidth() }}
        >
            {categories.map((category) => (
                <div
                    key={category.id}
                    className={styles.categoryBox}
                    onClick={() => handleCategoryClick(category.name)}
                >
                    <span
                        className={`${styles.categoryText} ${
                            selectedCategory === category.name ? styles.selected : ''
                        }`}
                    >
                        {category.name}
                    </span>
                    {selectedCategory === category.name && (
                        <div className={styles.imageWrapper}>
                            {renderCategoryImage(category.name)}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default PrimaryCategories;